import React, { useEffect, useState } from "react";
import { PortableText } from "@portabletext/react";
import urlBuilder from "@sanity/image-url";
import { useLocation, useParams } from "react-router-dom";
import Client from "../../lib/Client";
import styles from "./Article1.module.css";
import ArticlesHead from "./ArticlesHead";
import { Link } from "react-router-dom";

export default function Article1() {
  const [blogpost, setBlogPost] = useState([]);
  const { slug } = useParams();

  const urlFor = (source) =>
    urlBuilder({ projectId: "08c93u17", dataset: "production" }).image(source);

  const components = {
    types: {
      image: (props) => <img src={urlFor(props.value.asset._ref).url()} />,
    },
  };

  const location = useLocation().pathname;
  const parts = location.split("/");

  // Take the first element
  const firstPart = parts[1]; // Index 0 is an empty string because the string starts with a "/"
  // console.log(firstPart); // Output: "case-studies"

  // console.log(`article back button:${firstPart}`);

  useEffect(() => {
    Client.fetch(
      `*[slug.current == "${slug}"] {
        title,
        // slug,
        body,
        mainImage {
          asset -> {
            _id,
            url
          },
          alt
        }
      }`
    )
      .then((data) => {
        setBlogPost(data[0]);
        // console.log('sanity API article1', blogpost);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [slug]);
  // const bgColor = {
  //   backgroundColor: '#D6EAF8'
  // }

  // console.log("sanity API article1", blogpost);
  if (blogpost.length === 0) {
    // You can render a loading state or return null
    return (
      <center>
        <h1>Loading...</h1>
      </center>
    ); // Adjust this according to your needs
  }

  return (
    <>
      {blogpost && (
        <ArticlesHead
          heading={`${blogpost.title}`}
          image={blogpost.mainImage && blogpost.mainImage.asset.url}
        />
      )}

      <div className={styles.main_container}>
        {blogpost.body && (
          <PortableText value={blogpost.body} components={components} />
        )}

        <Link to={`/${firstPart}`} className={styles.button}>
          Back
        </Link>
      </div>
    </>
  );
}
